import React from 'react';

// Modern (jjfv2) header / hero / footer
import HeaderV2 from '../../components/headerV2/HeaderV2';
import FooterV2 from '../../components/footerV2/FooterV2';
import AboutHero from '../../components/aboutHero/AboutHero';
import BlogSidebar from './BlogSidebar';
import { Helmet } from 'react-helmet';

// CSS imoports
import '../AboutUsPage/aboutV2.css';
import './blogs.css';

// Image imports
import Blog1Img from "./../../images/blogs/diyas_blog.webp";

export default function Blogs() {
    return (
        <>
            <Helmet>
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
                <link
                    href="https://fonts.googleapis.com/css2?family=Anton&family=Inter:wght@400;500;600;700;800&display=swap"
                    rel="stylesheet"
                />

                {/* Basic Meta Tags */}
                <title>When Diyas Meet Hearts: Celebrating Diwali with JJFIndia | JJF India</title>
                <meta name="description" content="Experience Diwali with JJFIndia at Mowli Balak Ashram. Discover how the Jainam Jivika Foundation is lighting lives through connection, care, and the gift of time." />
                <meta name="keywords" content="JJFIndia Diwali celebration, Mewati Balak Ashram, Jainam Jivika Foundation, Diwali for a cause, joy of giving, community service Diwali, lighting lives initiative" />
                <meta name="robots" content="index, follow" />

                {/* Canonical URL */}
                <link rel="canonical" href="https://jjfindia.com/our-bulletin/when-diyas-meet-hearts" />

                {/* Open Graph */}
                <meta property="og:title" content="When Diyas Meet Hearts: Celebrating Diwali with JJFIndia | JJF India" />
                <meta property="og:description" content="Experience Diwali with JJFIndia at Mowli Balak Ashram. Discover how the Jainam Jivika Foundation is lighting lives through connection, care, and the gift of time." />
                <meta property="og:url" content="https://jjfindia.com/our-bulletin/when-diyas-meet-hearts" />

                {/* Twitter Cards */}
                {/* <meta name="twitter:card" content={metadata.twitter?.card} /> */}
                <meta name="twitter:title" content="When Diyas Meet Hearts: Celebrating Diwali with JJFIndia | JJF India" />
                <meta name="twitter:description" content="Experience Diwali with JJFIndia at Mowli Balak Ashram. Discover how the Jainam Jivika Foundation is lighting lives through connection, care, and the gift of time." />
            </Helmet>
            
            <div className="jjfv2">
                <HeaderV2 />
                <AboutHero
                    eyebrow="Our Bulletin"
                    title="Blogs"
                    crumbs={[{ label: 'Home', to: '/' }, { label: 'Blogs' }]}
                />
            </div>
            <main className="page_content">
                    <div style={{paddingBottom: "60px", paddingTop: "60px"}} className="container">
                        <div className='single-blog-container' >
                            <div className="blog-article">
                                <h1>When Diyas Meet Hearts: Celebrating Diwali with JJFIndia</h1>
                                <div>
                                    <img src={Blog1Img} alt='blog' />
                                </div>
                                <div style={{display: "flex", alignContent: "flex-end", width: "100%"}}>
                                    <span style={{ width:"100%", textAlign: "right", paddingTop: "16px", paddingBottom: "16px" }}>10 November, 2023</span>
                                </div>
                                <div>
                                    <p>it started with a simple question from a little boy at Mewati Balak Ashram: <strong>"Will you stay and play with us today?"</strong> His wide eyes and hopeful smile said more than words ever could. That single moment captured the essence of Diwali for us—a festival not of gifts or light alone, but of connection, care and shared joy.</p>
                                    <p>Diwali – the festival of lights. Homes glimmer with flickering diyas, sweets line the tables, and celebrations fill the air. Yet for Team Jainam Jivika Foundation (JJFIndia), this year's Diwali was about more than lamps; it was about lighting lives.</p>
                                    <h2 className='single-blog-sub-heading' >Packing Joy, One Box at a Time</h2>
                                    <p>Our morning began quietly, yet with gentle excitement. Tables were neatly lined with snacks, wrappers rustling softly as our team thoughtfully packed each box. This was no ordinary packing session – it was love, care and hope in a cardboard box. Each packet carried a piece of our hearts for children we were yet to meet.</p>
                                    <h2 className='single-blog-sub-heading' >The Journey to Mewati Balak Ashram</h2>
                                    <p>As we set out for the Ashram, our car was filled with laughter and anticipation. Yet nothing could have prepared us for the moment we stepped inside.</p>
                                    <p>Rows of children sat neatly, their eyes wide with curiosity and innocence. The air shifted instantly – soft giggles replaced silence, and shy smiles transformed the room into a space of pure joy. We realized, in that instant, what true happiness really looks like.</p>
                                    <h2 className='single-blog-sub-heading' >Celebrating Together</h2>
                                    <p>Introduction to the children and caretakers, we learned how eagerly the children awaited this visit. They weren't looking for gifts – they were waiting for people who cared.</p>
                                    <p>The celebration began simply: a cake-cutting ceremony. The children clapped, sang, and laughed together, filling the room with a melody of unfiltered joy. Then came the snack boxes. One by one, little hands reached out, whispering sincere "thank yous" that touched our hearts deeply. Some children held our hands a moment longer, speaking volumes without words.</p>

                                    <h2 className='single-blog-sub-heading' >Lessons in Simplicity</h2>
                                    <p>We spent the day with them – sharing stories, laughter, and listening to dreams colored with hope and simplicity. In their world, we found a depth of happiness often lost in our busy lives.</p>
                                    <p>As we left, the children waved goodbye, their smiles brighter than any diya. And in the quiet drive back, we realized something profound: joy doesn't always come from getting; it comes from giving a part of yourself to someone who needs it.</p>

                                    <h2 className='single-blog-sub-heading' >More Than Diwali</h2>
                                    <p>That day, we didn’t just celebrate Diwali.</p> 
                                    <p>We celebrated humanity.</p> 
                                    <p>We celebrated love.</p> 
                                    <p>We celebrated service.</p>
                                    <p>Because at JJFIndia, we know that when hearts give, light follows.</p>
                                    <span><strong>Team Jainam Jivika Foundation (JJFIndia)</strong></span>
                                </div>
                            </div>
                            <div>
                                <BlogSidebar />
                            </div>
                        </div>                    
                    </div>
                </main>
                <div className="jjfv2">
                    <FooterV2 />
                </div>
        </>
    );
}